// @ts-nocheck
import React from 'react'
import PropTypes from 'prop-types'
import CardOferta from '../Card/CardOferta'
import ShowCasePlaceHolder from './PlaceHolder'

const OfferShowCase = ({
  type,
  loading,
  offers,
  useLocation,
  zipCode,
  openLocationModal
}) => {
  const handleShowAllStores = () => {
    window.location.href = `/comunidade-iupp/search?zipcode=${zipCode}`
  }

  const hasStores = offers && offers.length > 0

  return (
    <ShowCasePlaceHolder isLoading={loading}>
      {hasStores && (
        <div>
          <div className='p0-mob'>
            <div className='overflowHidden mt-3'>
              <p className='floatLeft mt-2 titleOfertas'>
                {type === 'ecommerceOffers'
                  ? 'ofertas em lojas virtuais'
                  : 'ofertas pertinho de você'}
              </p>
              {type !== 'ecommerceOffers' ? (
                <div
                  className='buttonClickCep floatRight'
                  onClick={openLocationModal}
                >
                  <i className='icon icon_location' />
                  ativar localização
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
          <div className='d-flex flex-direct-b'>
            {offers && offers.slice(0, 4).map((product, ix) => (
              <CardOferta
                {...product}
                offer={product}
                key={ix}
                location={useLocation}
              />
            ))}

            <div
              className='btn-cards-mBairro mobile'
              onClick={handleShowAllStores}
            >
              Ver todas
            </div>
          </div>
          <div
            className='d-flex color-brand-1 tit-ver-todas-b mt-2'
            onClick={handleShowAllStores}
            title='Vai para ofertas por categorias'
          >
            <strong className='mr-1'>ver todas ofertas de lojas</strong>
            <i className='icon icon-sm icon_right color-brand-1' />
          </div>
        </div>
      )}
    </ShowCasePlaceHolder>
  )
}

export default OfferShowCase

OfferShowCase.propTypes = {
  type: PropTypes.string,
  loading: PropTypes.bool,
  offers: PropTypes.any,
  useLocation: PropTypes.bool,
  zipCode: PropTypes.string,
  openLocationModal: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/features/MeuBairro/newShowCase/OfferShowCase.js